import React from 'react';
import Baumumfang from '../components/Baumumfang';
import MyOrtMap from '../components/MyOrtMap';
import logo from '../assets/logo.png'; // Pfad ggf. anpassen
import { Link } from 'react-router-dom';
import './home.css'; // gleiche Styles wie bei Home verwenden


function BaumumfangUnterpullendorf() {
  return (
    <div className="home-container">
      <div className="home-diagramm">
        <div className='wetter-container'><h1 >BAUMUMFANG</h1></div>
        <Baumumfang ort="unterpullendorf" />
      </div>
    </div>
  );
}

export default BaumumfangUnterpullendorf;
